import {Grid, Text} from '@primer/react-brand'

import IdeList from '../_components/IdeList'

export function SmallIdeSection() {
  return (
    <Grid>
      <Grid.Column span={12}>
        <Text as="p" size="200" variant="muted" weight="medium" align="center" className="mb-5">
          GitHub Copilot is available on your favorite platforms:
        </Text>

        <IdeList type="small" location="pricing-cards" />
      </Grid.Column>
    </Grid>
  )
}

export default SmallIdeSection

try{ SmallIdeSection.displayName ||= 'SmallIdeSection' } catch {}